<template>
  <div class="flex gap-4">
    <div class="shrink-0">
      <TImage
        :src="image"
        rounded
        class="aspect-3/2 w-24 bg-surface-disabled"
      />
    </div>
    <div class="grow space-y-2">
      <TBody
        weight="semibold"
        class="line-clamp-2"
      >
        {{ name }}
      </TBody>
      <div
        v-if="rating && numberOfReviews"
        class="flex gap-2"
      >
        <TRating
          :number-of-reviews="numberOfReviews"
          :rating="rating"
          size="sm"
          icon-variant="primary"
        />
      </div>
      <TBody
        variant="muted"
        size="sm"
      >
        {{ meta }}
      </TBody>

      <slot name="badge" />
    </div>

    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  name?: string
  rating?: number
  numberOfReviews?: number
  meta?: string
  image?: string
}>()
</script>
